import { invokeApi } from '../bl_libs/invokeApi';
import { use_e2ee } from '../utils/utils';
import { LOCAL_STORAGE_KEYS } from '../utils/constants';

const getToken = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));

/*
 * institute_code: a school inside a network shares the network's org_code and
 * has product access of its own row, which the NETWORK sets. Sent only when
 * given, so every call about a network or a standalone school is unchanged.
 */
const withInstitute = (data, institute_code) => (institute_code ? { ...data, institute_code } : data);

export const getOrgAccessService = (org_code, institute_code) => {
    return invokeApi({
        path: '/dq_insider/dqin/pac/org/get',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: withInstitute({ org_code }, institute_code),
    }, use_e2ee());
};

// notify: true only from "Assign & notify" — the API then emails the org's admin (RQ-03).
export const setOrgOverridesService = (org_code, overrides, notify = false, institute_code) => {
    return invokeApi({
        path: '/dq_insider/dqin/pac/org/set',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: withInstitute(notify ? { org_code, overrides, notify: true } : { org_code, overrides }, institute_code),
    }, use_e2ee());
};

export const removeOrgOverrideService = (org_code, product_key, institute_code) => {
    return invokeApi({
        path: '/dq_insider/dqin/pac/org/remove_override',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: withInstitute({ org_code, product_key }, institute_code),
    }, use_e2ee());
};

export const resetOrgOverridesService = (org_code, institute_code) => {
    return invokeApi({
        path: '/dq_insider/dqin/pac/org/reset',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: withInstitute({ org_code }, institute_code),
    }, use_e2ee());
};
